import * as yup from "yup";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";
import { authService } from "../../services/AuthService";

const requestSchema = yup.object({
  password: yup.string().required(),
  question_id: yup.number().required(),
  answer: yup.string().required(),
});

export const useSaveUserSecurityAnswerMutation = (options = {}) => {
  const queryClient = useQueryClient();

  return useMutation(
    (dto) => {
      const req = requestSchema.validateSync(dto, {
        strict: true,
      });
      return http.post(HTTP_ENDPOINTS.user.saveSecurityQuestionAnswer(), {
        ...req,
        wpu_id: authService.getLoginData().wpuId,
      });
    },
    {
      ...options,
      onSuccess: (...args) => {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.account],
        });
        options?.onSuccess?.(...args);
      },
    },
  );
};
